import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Divider } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
// import DepositModal from "./paymentModals/DepositModal";
// import WithdrawalModal from "./paymentModals/WithdrawalModal";

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: "#fff",
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: "left",
	color: (theme.vars ?? theme).palette.text.secondary,
	minWidth: "22Irem",
	height: "5rem",

	...theme.applyStyles("dark", {
		backgroundColor: "#1A2027",
	}),
}));

const message = `00.00`;

export default function AccountBalanceUtil() {
	const { setAuth } = useAuth();

	const gotoDepositPage = () => {
		setAuth((prev) => ({ ...prev, depositRoute: true }));
	};

	const gotoWithdrawalPage = () => {
		setAuth((prev) => ({ ...prev, withdrawalRoute: true }));
	};

	return (
		<Box
			sx={{
				flexGrow: 1,
				overflow: "hidden",
				px: 3,
				flexDirection: "row",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				width: "100%",
			}}>
			{" "}
			<Stack
				spacing={1}
				direction="row"
				sx={{
					alignItems: "center",
					justifyContent: "space-around",
					minWidth: "100%",
					width: "25rem",

					borderRadius: 2,
					marginX: "auto",
					border: "1px solid #45484A",
					py: "0.5rem",
				}}>
				{/* <DepositModal />
				<WithdrawalModal /> */}
				<Button
					onClick={() => {
						gotoDepositPage();
					}}
					sx={{
						width: "45%",
						fontSize: "0.9rem",
						fontWeight: "bold",
						wordSpacing: "0.1rem",
						border: 1,
						borderColor: "white",
						p: "0.5rem",
						bgcolor: "yellow",
						color: "black",
					}}>
					Deposit <CallReceivedIcon sx={{ fontSize: "1.5rem", ml: "0.3rem" }} />
				</Button>

				<Button
					onClick={() => {
						gotoWithdrawalPage();
					}}
					sx={{
						width: "45%",

						fontSize: "0.9rem",
						fontWeight: "bold",
						wordSpacing: "0.1rem",
						p: "0.5rem",
						border: 1,
						borderColor: "gray",
						bgcolor:
							"linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
					}}>
					Withdraw <CallMadeIcon sx={{ fontSize: "1.5rem", ml: "0.3rem" }} />
				</Button>
				{/* <Link
					to="/dashboard/deposit"
					className="font-bold   bg-green-500 tracking-wide p-[0.5rem]">
					Deposit
				</Link> */}
				{/* <Divider sx={{ width: "50%", background: "green" }} />

				<Typography variant="h6">
					<TrendingUpIcon sx={{ color: "green", mr: 1 }} />
					Profit
				</Typography>
				<Typography noWrap sx={{ fontWeight: "bold", letterSpacing: 1 }}>
					{message}
				</Typography> */}
			</Stack>
		</Box>
	);
}

{
	/* <Item sx={{ my: 1, mx: "auto", p: 2 }}>
				<Stack spacing={2} direction="row" sx={{ alignItems: "center" }}>
					<Stack>
						<Avatar>W</Avatar>
					</Stack>
					<Stack sx={{ minWidth: 0 }}>
						<Typography noWrap>{message}</Typography>
					</Stack>
				</Stack>
			</Item> */
}
